import absPrice from "./absPrice.filter";

const absPriceModule = angular
  .module("app.filters.absPrice", [])
  .filter("absPrice", absPrice);

export default absPriceModule;



// WEBPACK FOOTER //
// ./src/filters/absPrice/absPrice.module.js